<form [formGroup]="parcelForm">
    <app-simple-select-value-accessor label="Przedmiot"
                                  [data]="items"
                                  formControlName="itemId">
    </app-simple-select-value-accessor>
    <app-attachment-select formControlName="attachment"></app-attachment-select>
</form>